<template>
  <v-card v-if="selectedOrder" flat class="container--fluid">
    <v-card flat class="container--fluid bg-gray no-margins zindex-1">
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-row align="center" justify="space-between">
            <v-col cols="12" lg="7" sm="6" class="subtitle-1">
              <h4 class="mb-1">Beställning</h4>
              {{ get(selectedOrder, 'company.name', null) }}, {{ get(selectedOrder, 'company.postalCity', null) }}
            </v-col>
            <v-col cols="12" lg="5" sm="6" class="text-right d-flex">
              <v-select
                label="STATUS"
                outlined
                :items="basicDistanceOrderStates"
                item-text="name"
                item-value="id"
                :rules="[rules.required]"
                v-model="selectedOrder.stateId"
                hide-details
                :disabled="!editState"
              ></v-select>
              <v-icon @click="editState=!editState" class="mt-4 ml-3" v-if="!editState" :disabled="!canUpdate">$sl-edit</v-icon>
              <v-icon class="mt-4 ml-3" @click="updateState()" v-else :disabled="!canUpdate">$sl-check</v-icon>
            </v-col>
          </v-row>
        </v-form>
        <template v-if="selectedOrder.orderedAt">
          <div class="body-2 mt-4">Beställning gjord {{ get(selectedOrder, 'orderedAt', null) | date }}</div>
        </template>
      </v-card-text>
    </v-card>
    <v-card flat class="container--fluid">
      <v-tabs v-model="tab">
        <v-tabs-slider></v-tabs-slider>

        <v-tab>Fakturaunderlag</v-tab>

        <v-tooltip bottom :disabled="selectedOrder.state >= paidStateId">
          <template v-slot:activator="{ on }">
            <div class="d-inline-flex" v-on="on">
              <v-tab v-on="on" :disabled="selectedOrder.state < paidStateId">Beställning</v-tab>
            </div>
          </template>
          <span>Endast betalda ordrar kan beställas</span>
        </v-tooltip>

        <v-tab>
          <v-badge
            :content="'!'"
            :value="personHasNotes"
          >Kommentarer</v-badge>
        </v-tab>

        <v-tab>Administrera</v-tab>

        <v-tab-item>
          <InvoiceDetail @updated="updated"></InvoiceDetail>

        </v-tab-item>

        <v-tab-item>
          <OrderingDetail @updated="updated"></OrderingDetail>
        </v-tab-item>

        <v-tab-item>
          <OrderComments @updated="updated"></OrderComments>
        </v-tab-item>

        <v-tab-item>
          <OrderDelete :id="Number($route.params.id)"></OrderDelete>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import InvoiceDetail from '@/components/order/InvoiceDetail'
import OrderingDetail from '@/components/order/OrderingDetail'
import OrderComments from '@/components/order/OrderComments'
import OrderDelete from '@/components/order/OrderDelete'
import {RulesMixin, CanIDo} from '@/components/mixins'
import find from 'lodash/find'
import get from 'lodash/get'

// @group Order
// OrderDetail component
export default {
  name: 'OrderDetail',

  mixins: [RulesMixin, CanIDo],

  components: {
    InvoiceDetail,
    OrderingDetail,
    OrderDelete,
    OrderComments
  },

  data: () => ({
    tab: 0,
    editState: false
  }),

  created() {
    this.fetchOrder()
  },

  watch: {
    '$route.params.id': {
      handler: (newVal, OldVal) => {
        this.fetchOrder()
      }
    }
  },

  computed: {
    ...mapGetters('basic', ['basicDistanceOrderStates']),
    ...mapGetters('order', ['selectedOrder']),

    paidStateId() {
      const ps = find(this.basicDistanceOrderStates, ['state', 'paid'])
      return ps ? ps.id : -1
    },

    personHasNotes() {
      const comments = get(this, 'selectedOrder.comments', []).length
      const notes = get(this, 'selectedOrder.student.notes', []).length
      const applicationNotes = get(this, 'selectedOrder.application.notes', []).length
      
      return Boolean(comments || notes || applicationNotes)
    }
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('order', 'update');
    },
  },

  methods: {
    get,

    ...mapActions('order', ['setSelectedOrder', 'updateSelectedOrder']),
    /**
     * @vuese
     * Used to update distance order
     * @arg The argument is an integer representing  distance order id and param is state id
     */
    updateState() {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Du måste välja en status.')
        return
      }
      this.editState = !this.editState

      if (this.$route.params.id > 0) {
        // @vuese
        //  Existing item
        API.updateDistanceOrder(this.$route.params.id, {
          data: {stateId: String(this.selectedOrder.stateId)}
        })
          .then(response => {
            this.$events.fire('showInfo', 'Sparad.')
            /**
             * @vuese
             * Used to update selected order in local store with new state id
             */
            this.updateSelectedOrder({
              stateId: this.selectedOrder.stateId,
              state: find(this.basicDistanceOrderStates, ['id', this.selectedOrder.stateId])
            })
          })
          .catch(error => {
            console.log('There was an error:', error)
            this.$events.fire('showError', 'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.')
          })
      }
    },

    updated() {
      this.fetchOrder()
    },
    /**
     * @vuese
     * Used to fetch order
     * @arg The argument is an integer representing  distance order id
     */
    fetchOrder() {
      API.getDistanceOrder(this.$route.params.id)
        .then(response => {
          // @vuese
          // Set selected order  to local store distance order
          if (response && response.data&&response.data.company&&response.data.company.postalZip) {
            response.data.company.postalZip =  this.$options.filters.postalZipFormat(response.data.company.postalZip)
          }

          this.setSelectedOrder(response.data)
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style lang="scss">
</style>
